const analyticsId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

// log the pageview with their URL
export const pageview = (url: string) => {
  if (typeof window !== "undefined") {
    // @ts-ignore
    window.gtag?.("config", process.env.REACT_APP_GOOGLE_ANALYTICS_ID, {
      page_path: url,
    });
  }
};

// log specific events happening.
export const event = ({ action, params }: { action: string; params?: { [key: string]: any } }) => {
  if (typeof window !== "undefined") {
    // @ts-ignore
    window.gtag?.("event", action, params);
  }
};

export const logWalletConnected = () => {
  if (analyticsId) {
    event?.({
      action: "wallet_connected",
    });
  }
};

export const setUserId = (walletId: string) => {
  if (analyticsId) {
    // @ts-ignore
    window.gtag?.("set", { userId: walletId });
  }
};

export const logDividendClaimed = () => {
  if (analyticsId) {
    event?.({
      action: "rewards_claimed",
    });
  }
};

export const logPancakeSwapClicked = () => {
  if (analyticsId) {
    return event?.({
      action: "click_buy_on_pancake",
    });
  }
};
